import fetch from '@giro/shared-utils/fetch.util';

export default async function postApiTerminalsRegistrationsIdOtpService(
  id,
  body: any = {}
) {
  return fetch(`terminals/registrations/${id}/otp`, {
    method: 'POST',
    ms: 'PDV',
    auth: true,
    body: JSON.stringify(body),
  });
}
